(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promotion_1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('woddys-announcement')) {
  customElements.define('woddys-announcement', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      if (!this.isConnected || this.controller) return;
      this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
      if (this.items.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = matchMedia('(max-width: 767px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.list = this.querySelector('.woddys-announcement__list');
      this.toggle = this.querySelector('[data-announcement-toggle]');
      this.index = 0;
      this.paused = this.reduced.matches;
      this.hovered = false;
      this.delay = Math.max(3000, Number(this.dataset.delay) || 5000);
      this.classList.add('is-ready');

      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.sync();
      }, options);
      this.querySelector('[data-announcement-next]').addEventListener('click', () => {
        this.paused = true;
        this.advance();
      }, options);
      this.addEventListener('focusin', (event) => {
        if (event.target.closest('.woddys-announcement__list')) {
          this.paused = true;
          this.sync();
        }
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
          this.hovered = true;
          this.sync();
        }
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.sync();
      }, options);
      this.mobile.addEventListener('change', () => {
        const focusedIndex = this.items.findIndex(item => item.contains(document.activeElement));
        if (focusedIndex >= 0) this.index = focusedIndex;
        this.render();
      }, options);
      this.reduced.addEventListener('change', () => {
        if (this.reduced.matches) this.paused = true;
        this.sync();
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.render();
    }

    advance() {
      this.index = (this.index + 1) % this.items.length;
      this.render();
    }

    render() {
      this.list.setAttribute('aria-live', this.mobile.matches && this.paused ? 'polite' : 'off');
      this.items.forEach((item, index) => {
        item.hidden = this.mobile.matches && index !== this.index;
      });
      this.sync();
    }

    sync() {
      clearTimeout(this.timer);
      this.classList.toggle('is-paused', this.paused);
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.list.setAttribute('aria-live', this.mobile.matches && this.paused ? 'polite' : 'off');
      if (this.mobile.matches && !this.paused && !this.hovered && !document.hidden) {
        this.timer = setTimeout(() => this.advance(), this.delay);
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woddys-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('woddys-navigation')) {
    customElements.define('woddys-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const disclosures = [...this.querySelectorAll('[data-woddys-disclosure]')];
        const mobile = this.querySelector('.woddys-nav__mobile');
        const updatePosition = () => {
          const header = this.closest('.woddys-header-inner');
          if (header) this.style.setProperty('--woddys-nav-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
        };
        const updateScroll = () => document.documentElement.classList.toggle('woddys-mobile-menu-open', Boolean(mobile?.open));
        const close = (restoreFocus = false) => {
          const current = disclosures.find(item => item.open);
          disclosures.forEach(item => { item.open = false; });
          updateScroll();
          if (restoreFocus) current?.querySelector('summary')?.focus();
        };
        disclosures.forEach(disclosure => {
          disclosure.addEventListener('toggle', () => { updatePosition(); updateScroll(); }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && disclosures.some(item => item.open)) {
            event.preventDefault();
            close(true);
          }
        }, options);
        this.addEventListener('click', event => {
          if (event.target instanceof Element && event.target.closest('.woddys-nav__panel a, .woddys-nav__mega a')) close();
        }, options);
        document.addEventListener('click', event => {
          if (event.target instanceof Node && !this.contains(event.target)) close();
        }, options);
        document.addEventListener('focusin', event => {
          if (event.target instanceof Node && !this.contains(event.target)) close();
        }, options);
        window.addEventListener('resize', updatePosition, options);
        this.desktop = window.matchMedia('(min-width: 992px)');
        this.desktop.addEventListener('change', event => {
          const hadFocus = this.contains(document.activeElement);
          close();
          if (hadFocus) this.querySelector(event.matches ? '.woddys-nav__shop-toggle' : '.woddys-nav__toggle')?.focus();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        document.documentElement.classList.remove('woddys-mobile-menu-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
